import { verticalApiEndpoint } from '../../url'
import { ApiError } from '../common'

const defaultHeaders = {
  'Content-Type': 'application/json',
}

export const callVerticalApi = async <T extends {}>(
  path: string,
  options: RequestInit = {}
): Promise<T> => {
  const url = verticalApiEndpoint + path
  const response = await fetch(url, {
    headers: defaultHeaders,
    mode: 'cors',
    ...options,
  })
  if (!response.ok) {
    throw new ApiError(
      response,
      `Request failed: ${response.status} url: ${url} method: ${
        options.method ? options.method : 'GET'
      }`
    )
  } else {
    const json = (await response.json()) as T
    return json
  }
}
